import script from "./body.vue?vue&type=script&setup=true&lang=js"
export * from "./body.vue?vue&type=script&setup=true&lang=js"

import "./body.vue?vue&type=style&index=0&id=bc423644&lang=scss"

const __exports__ = script;

export default __exports__